import withRouter from 'containers/withRouter';
import withUserType from 'containers/withUserType';
import { compose, withProps } from 'recompose';

export default compose(
  withUserType,
  withRouter,
  withProps(
    ({
      router: {
        match: {
          params: { orgId },
        },
      },
      user,
    }) => {
      const { type, affiliations } = user;
      const selectedAffiliation = affiliations?.find(
        el => el?.organization?.uuid === orgId,
      );
      const isAlumni = !!affiliations?.find(affil => !!affil.alumniInformation);
      const isHESchoolAffiliation =
        type.includes('member') &&
        selectedAffiliation?.organization?.organizationType === 'HESchool';

      return {
        user: {
          ...user,
          isHESchoolAffiliation,
          isAlumni,
          selectedOrganizationUuid: selectedAffiliation?.organization?.uuid,
          selectedAffiliationUuid: selectedAffiliation?.uuid,
        },
      };
    },
  ),
);
